export const ViewBids = {
    Titles: {
        jobPublished: 'Job Published',
        biddingInProgress: 'Bidding in Progress'
    },
    Text: {
        provider: 'Provider',
        complimentsReceived: 'Compliments received:',
        hauler: 'Hauler',
        jobReview: 'Job under review...'
    },
    Buttons: {
        Cancel: {
            label: 'Cancel'
        },
        Accept: {
            label: 'Accept Bid'
        },
        Select: {
            label: 'Select'
        }
    },
    Errors: {
        Messages: {
            jobTimeOut: 'Job expired',
            jobCancelled: 'Job Cancelled',
            error: 'Error',
            cannotLoadBids: 'Can not load bids.',
            jobStatusError: 'Can not load job status.'
        }
    }
}



// WEBPACK FOOTER //
// ./src/localization/ViewBids.ts